/**
 * Translates system-defined series names (like sentiment labels)
 * while leaving user-generated names (like keywords, profile names) untouched
 */
export function translateSeriesNames(
  series: any,
  t: (key: string) => string,
): any {
  if (!series) return series;

  if (Array.isArray(series)) {
    return series.map((s) => translateSingleSeries(s, t));
  }

  return translateSingleSeries(series, t);
}

function translateSingleSeries(series: any, t: (key: string) => string): any {
  if (!series || typeof series !== "object") return series;

  const translated = { ...series };

  if (translated.name) {
    translated.name = translateSystemLabel(translated.name, t);
  }

  if (Array.isArray(translated.data)) {
    translated.data = translated.data.map((item: any) => {
      if (item && typeof item === "object" && item.name) {
        return {
          ...item,
          name: translateSystemLabel(item.name, t),
        };
      }
      return item;
    });
  }

  return translated;
}

function translateSystemLabel(
  label: string,
  t: (key: string) => string,
): string {
  const systemLabels: Record<string, string> = {
    Positive: "appliedFilters.positive",
    Neutral: "appliedFilters.neutral",
    Negative: "appliedFilters.negative",
  };

  if (systemLabels[label]) {
    return t(systemLabels[label]);
  }

  return label;
}
